import { Link } from "gatsby"
import PropTypes from "prop-types"
import Logo from "../../../images/site-logo.svg"
import MenuIcon from "../../../images/mobile-menu.svg"
import MainMenu from "../../../menus/header"
import ClientOnly from "../../../utils/hooks/ClientOnly.js"
import GoogleSearch from "../../googlesearch/searchbar";
import GoogleSearchMobile from "../../googlesearch/searchbar-mobile";
import React, { useState } from 'react'




function Header() {

const [isMobileSearchActive, setMobileSearchActive] = useState(false);
const toggleClass = () => {
  setMobileSearchActive(!isMobileSearchActive);
};

const [isMobileMenuActive, setMobileMenuActive] = useState(false);
const toggleMenuClass = () => {
  setMobileMenuActive(!isMobileMenuActive);
};

return(
<div id="site-header" >
  <header className="header clearfix" role="banner">
    <div className="container clearfix">
      <div className="row clearfix">

        <div className="col-md-4 col-xs-5">
          <div className="header__logo">
            <a href="https://www.southglos.gov.uk" title="South Gloucestershire Council">
              <img src={Logo} alt="South Gloucestershire Council Logo"/>
            </a>
          </div>       
        </div>

        <div className="col-lg-8 col-md-8 hidden-sm hidden-xs pull-right">
            <div className="ads pull-right">
              <iframe title="Advertisement" src="/leaderboardad.html" referrerPolicy="same-origin" style={{maxWidth:'800px', width:'100%', height:'110px', border:'1px solid #ccc', marginTop:'10px'}}></iframe>
              <p className="text-center ads-text-leaderboard">Advertisement</p>
            </div>
        </div>

        <div className="hidden-lg hidden-md col-sm-7 col-xs-7 pull-right text-right">
            <a className="button__sign-in" href="https://account.southglos.gov.uk">
              <i class="fa fa-user mright-5"></i><span className="button__sign-in__text">Sign in</span>
            </a>
            <button className="button__search--mobile"  onClick={toggleClass}>
                <span className="sr-only">Search</span>
            </button>
            <button className="button__navigation" onClick={toggleMenuClass}>
                <img src={MenuIcon} className="mobileMenuIcon"/>
                <span className="sr-only">Menu</span>
            </button>
        </div>

      </div>
    </div>
  </header>

  <div className="navigation">
    <div className="container clearfix">
      <div className="header-container">
        <div className="nav-container">
          <nav className={isMobileMenuActive ? 'menu-navigation mobile_menu--open' : 'menu-navigation '} role="navigation" aria-label="Main navigation">
          <MainMenu />
          </nav>
        </div>
        <div className="search-container">
            <GoogleSearch /> 
        </div>  
      </div>
      <div className={isMobileSearchActive ? 'show row clearfix' : 'hidden row clearfix'}>
        <GoogleSearchMobile/>
      </div>
    </div>
  </div>
</div>
)
}

export default Header
